import React from 'react';
import { PHONE_LIST } from '../constants';
import Image from '@/Framework/Router/Next/Image';

import phonesStyles from './phones.scss';

const Phones = () => (
  <div className={ phonesStyles.phoneWrapper }>
    <div className={ phonesStyles.title }>
      By Phone
    </div>
    { PHONE_LIST.map(({ icon, title, value }) => (
      <div
        key={ title }
        className={ phonesStyles.contactWrapper }
      >
        <span className={ phonesStyles.icon }>
          <Image
            src={ icon }
            width={ 30 }
            height={ 30 }
            alt={ title }
          />
        </span>
        <div>
          <span className={ phonesStyles.contactTitle }>
            { title }
          </span>
          <span className={ phonesStyles.value }>
            <a href={ `tel:${ value }` }>{ value }</a>
          </span>
        </div>
      </div>
    )) }
  </div>
);

export default Phones;
